export interface GetQuantityDisplayParams {
  choiceSet: ValidatedChoiceSet;
  requiredText: string;
  optionalText: string;
  stages?: NestedIngredientsStages;
}

export const getQuantityDisplay = (
  params: GetQuantityDisplayParams,
): string => {
  let selectedQuantity = 0;
  let totalQuantity = 0;

  const { choiceSet, requiredText, optionalText, stages } = params;
  const { required, quantity, min, max } = choiceSet;

  const text = required || min ? requiredText : optionalText;

  selectedQuantity = quantity;

  if (stages) {
    selectedQuantity = 0;
    for (const choice of choiceSet.choices) {
      const choiceQuantity = getChoiceSetIndividualQty(
        choice,
        choiceSet,
        stages,
      );
      if (choiceQuantity) {
        selectedQuantity += choiceQuantity;
      }
    }
  }

  if (required) {
    if (min === 1 && max === 1) {
      return text;
    }

    totalQuantity = min || 0;

    if (selectedQuantity > (min || 0)) {
      selectedQuantity = min || 0;
    }
  } else {
    if (max === 1) {
      return text;
    }

    totalQuantity = max || 0;
  }

  return `${text} ${selectedQuantity}/${totalQuantity}`;
};

export const getChoiceSetIndividualQty = (
  choice: ChoiceWithQuantity,
  choiceSet: ValidatedChoiceSet,
  stages: NestedIngredientsStages | undefined,
): number => {
  if (!stages) {
    return 0;
  }

  const steps = Object.keys(stages).length - 1;

  if (steps) {
    const choiceSelection = stages[steps.toString()] as {
      [key: string]: ChoiceWithQuantity[];
    };
    const index = steps === 2 ? choiceSet.id : choiceSet.key;

    if (!choiceSelection || !choiceSelection[index]) {
      return 0;
    }

    return choiceSelection[index].filter(
      (selection) => selection.id === choice.id,
    ).length;
  }

  return 0;
};
